import { render, staticRenderFns } from "./curtomerProfileDetails.vue?vue&type=template&id=48deee78&scoped=true"
import script from "./curtomerProfileDetails.vue?vue&type=script&lang=js"
export * from "./curtomerProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./curtomerProfileDetails.vue?vue&type=style&index=0&id=48deee78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48deee78",
  null
  
)

export default component.exports